import { PureComponent, ReactNode } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { TrialOrderType } from '../pages/trialOrder/TrialOrderHomePage';
import { GO_TO_HE_TRIAL_ORDER } from '../routes/paths';
import { Modal } from 'antd';
import { OneMgSvg } from './prescriptionPad/rightPanel/finishScreen/OrderMedicineUtils';
import { track } from '../tracking';

interface Props extends RouteComponentProps {
    isVisible?: boolean;
    closeMe: () => void;
    from: string;
}

interface State {
    type: TrialOrderType | '';
}

class TrialOrderSelectionModal extends PureComponent<Props, State> {
    state: State = { type: '' };

    componentDidUpdate = () => {
        const { from } = this.props;
        this.props.isVisible && track('TRIAL_ORDER_SELECTION_MODAL', { from });
    };

    setType = (type: TrialOrderType): void => {
        this.setState({ type });
    };

    onContinue = (): void => {
        const { history } = this.props;
        const { type } = this.state;
        if (!type) return;
        history.push(GO_TO_HE_TRIAL_ORDER(type, 'start'));
        track('TRIAL_ORDER_TYPE_SELECTION', { type });
    };

    render(): ReactNode {
        const { isVisible, closeMe } = this.props;
        const { type } = this.state;
        const { setType, onContinue } = this;

        return (
            <Modal
                onCancel={closeMe}
                width={400}
                closable={false}
                visible={isVisible}
                destroyOnClose
                footer={null}
                bodyStyle={{
                    padding: '0px',
                    borderRadius: '12px !important',
                    height: '310px',
                    display: 'flex',
                    flexDirection: 'column',
                }}
                className="overflow-hidden rounded-12"
                style={{ height: '310px' }}
            >
                <div className="h-full w-full flex flex-col">
                    <div className="px-16 py-12 flex items-center justify-between">
                        <p className="text-20 space-x-6">
                            <span>Select</span>
                            <span className="font-700 text-white bg-darwin-green-primary rounded-8 px-10 py-4">
                                Free
                            </span>
                            <span>trial order experience</span>
                        </p>
                        <p className="pt-4">
                            <svg
                                className="w-30 h-30 cursor-pointer"
                                viewBox="0 0 28 28"
                                xmlns="http://www.w3.org/2000/svg"
                                onClick={closeMe}
                            >
                                <rect width="28" height="28" rx="4" fill="white" />
                                <path
                                    d="M17.8848 10.6035L14.8379 13.6504L17.8594 16.6719C18.1133 16.9004 18.1133 17.2812 17.8594 17.5098C17.6309 17.7637 17.25 17.7637 17.0215 17.5098L13.9746 14.4883L10.9531 17.5098C10.7246 17.7637 10.3438 17.7637 10.1152 17.5098C9.86133 17.2812 9.86133 16.9004 10.1152 16.6465L13.1367 13.625L10.1152 10.6035C9.86133 10.375 9.86133 9.99414 10.1152 9.74023C10.3438 9.51172 10.7246 9.51172 10.9785 9.74023L14 12.7871L17.0215 9.76562C17.25 9.51172 17.6309 9.51172 17.8848 9.76562C18.1133 9.99414 18.1133 10.375 17.8848 10.6035Z"
                                    fill="#1A1A1A"
                                />
                            </svg>
                        </p>
                    </div>
                    <div className="flex-1 px-16 py-16 bg-darwin-neutrals-50 border-t border-b border-darwin-neutral_new-200">
                        <div className="font-700 p-16 rounded-12 bg-white space-y-12">
                            <div
                                className={`cursor-pointer px-16 py-10 flex items-center space-x-8 rounded-12 border ${
                                    type === 'pharma'
                                        ? 'border-darwin-accent-bright-blue-800 bg-darwin-accent-bright-blue-100 popup-overlay-show'
                                        : 'border-darwin-neutral_new-200'
                                }`}
                                onClick={() => setType('pharma')}
                            >
                                <p>
                                    {type === 'pharma' ? (
                                        <svg
                                            className="w-24 h-24 fill-darwin-accent-bright-blue-800"
                                            viewBox="0 0 24 24"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path d="M12 20C9.125 20 6.5 18.5 5.0625 16C3.625 13.5312 3.625 10.5 5.0625 8C6.5 5.53125 9.125 4 12 4C14.8438 4 17.4688 5.53125 18.9062 8C20.3438 10.5 20.3438 13.5312 18.9062 16C17.4688 18.5 14.8438 20 12 20ZM12 9C10.9062 9 9.9375 9.59375 9.375 10.5C8.84375 11.4375 8.84375 12.5938 9.375 13.5C9.9375 14.4375 10.9062 15 12 15C13.0625 15 14.0312 14.4375 14.5938 13.5C15.125 12.5938 15.125 11.4375 14.5938 10.5C14.0312 9.59375 13.0625 9 12 9Z" />
                                        </svg>
                                    ) : (
                                        <svg
                                            className="w-24 h-24 fill-darwin-neutral_new-800"
                                            viewBox="0 0 24 24"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path d="M18.5 12C18.5 9.6875 17.25 7.5625 15.25 6.375C13.2188 5.21875 10.75 5.21875 8.75 6.375C6.71875 7.5625 5.5 9.6875 5.5 12C5.5 14.3438 6.71875 16.4688 8.75 17.6562C10.75 18.8125 13.2188 18.8125 15.25 17.6562C17.25 16.4688 18.5 14.3438 18.5 12ZM4 12C4 9.15625 5.5 6.53125 8 5.09375C10.4688 3.65625 13.5 3.65625 16 5.09375C18.4688 6.53125 20 9.15625 20 12C20 14.875 18.4688 17.5 16 18.9375C13.5 20.375 10.4688 20.375 8 18.9375C5.5 17.5 4 14.875 4 12Z" />
                                        </svg>
                                    )}
                                </p>
                                <button>Order Medicine</button>
                                <p>
                                    <OneMgSvg width="80" height="30" />
                                </p>
                            </div>
                            <div
                                className={`cursor-pointer px-16 py-10 flex items-center space-x-8 rounded-12 border ${
                                    type === 'lab'
                                        ? 'border-darwin-accent-bright-blue-800 bg-darwin-accent-bright-blue-100 popup-overlay-show'
                                        : 'border-darwin-neutral_new-200'
                                }`}
                                onClick={() => setType('lab')}
                            >
                                <p>
                                    {type === 'lab' ? (
                                        <svg
                                            className="w-24 h-24 fill-darwin-accent-bright-blue-800"
                                            viewBox="0 0 24 24"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path d="M12 20C9.125 20 6.5 18.5 5.0625 16C3.625 13.5312 3.625 10.5 5.0625 8C6.5 5.53125 9.125 4 12 4C14.8438 4 17.4688 5.53125 18.9062 8C20.3438 10.5 20.3438 13.5312 18.9062 16C17.4688 18.5 14.8438 20 12 20ZM12 9C10.9062 9 9.9375 9.59375 9.375 10.5C8.84375 11.4375 8.84375 12.5938 9.375 13.5C9.9375 14.4375 10.9062 15 12 15C13.0625 15 14.0312 14.4375 14.5938 13.5C15.125 12.5938 15.125 11.4375 14.5938 10.5C14.0312 9.59375 13.0625 9 12 9Z" />
                                        </svg>
                                    ) : (
                                        <svg
                                            className="w-24 h-24 fill-darwin-neutral_new-800"
                                            viewBox="0 0 24 24"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path d="M18.5 12C18.5 9.6875 17.25 7.5625 15.25 6.375C13.2188 5.21875 10.75 5.21875 8.75 6.375C6.71875 7.5625 5.5 9.6875 5.5 12C5.5 14.3438 6.71875 16.4688 8.75 17.6562C10.75 18.8125 13.2188 18.8125 15.25 17.6562C17.25 16.4688 18.5 14.3438 18.5 12ZM4 12C4 9.15625 5.5 6.53125 8 5.09375C10.4688 3.65625 13.5 3.65625 16 5.09375C18.4688 6.53125 20 9.15625 20 12C20 14.875 18.4688 17.5 16 18.9375C13.5 20.375 10.4688 20.375 8 18.9375C5.5 17.5 4 14.875 4 12Z" />
                                        </svg>
                                    )}
                                </p>
                                <button>Book Lab Test</button>
                                <p>
                                    <img
                                        src="/images/labs_vendors.gif"
                                        alt={'v_001'}
                                        className="h-30 min-w-72"
                                    />
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="px-16 py-12 flex justify-center">
                        <button
                            className="text-13 font-700 px-12 py-10 text-white bg-darwin-accent-bright-blue-800 rounded-8 disabled:opacity-60"
                            disabled={!type}
                            onClick={onContinue}
                        >
                            Continue
                        </button>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default withRouter(TrialOrderSelectionModal);
